import { z } from 'zod';
/**
 * Route params for the endpoints addressing a single manual job. Orchestrator numbers its jobs, and
 * the routes only match digits, so the id arrives as a numeric string and is read back as a number.
 * Digits past the safe integer range would round to a different id than the caller asked for.
 */
export const ManualJobIdParamsSchema = z
    .object({
    jobId: z
        .string()
        .regex(/^\d+$/)
        .transform(Number)
        .refine((jobId) => Number.isSafeInteger(jobId)),
})
    .strict();
//# sourceMappingURL=params.js.map